import React from "react";
import ViewBoxContainer from "../../Layout/ViewBoxContainer";

const SentryError = ({ error, componentStack, resetErrorBoundary }) => {
    console.log("Error Page");
    return <p>Error</p>;
};

export default SentryError;
